import { useBooleanFlagValue } from "@openfeature/react-sdk";
import { FeatureFlagVariables } from "../../../../constants/featureFlag";

const DEFAULT_IMAGE_SRC = "/images/bonusx-logo-large.svg";
const BONUSXER_IMAGE_SRC = "/images/bonusxer-logo-large.svg";

const DEFAULT_FLAG_VALUE = false;

export function DefaultLogo() {
  const isBonusxUser = useBooleanFlagValue(FeatureFlagVariables.isBonusxUser, DEFAULT_FLAG_VALUE, {
    updateOnContextChanged: true,
  });

  const logoSrc = isBonusxUser ? BONUSXER_IMAGE_SRC : DEFAULT_IMAGE_SRC;

  return (
    <picture>
      <source type="image/svg+xml" srcSet={logoSrc} />
      <img width={142} height={14} src={logoSrc} alt="BonusX" />
    </picture>
  );
}
